import React from "react";
import './loadingSpinner.css';

interface LoadingSpinnerProps {
    size?: 'small' | 'medium' | 'large';
    message?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ size = 'medium', message }) => {
    return (
        <div className={`LoadingSpinner-Container LoadingSpinner-${size}`}>
            <div className="LoadingSpinner-Spinner">
                <div className="LoadingSpinner-Circle"></div>
                <div className="LoadingSpinner-Circle"></div>
                <div className="LoadingSpinner-Circle"></div>
            </div>
            {message && <div className="LoadingSpinner-Message">{message}</div>}
        </div>
    );
};

export default LoadingSpinner;

